import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from '../../services/firebase.service';
import { Logger } from 'src/app/services/datadog.logger.service';
import { FormControl, FormGroup } from '@angular/forms';
import * as uuid from 'uuid'
import { Appointment } from '../../models/appointment';
import { Location } from '@angular/common'

@Component({
  selector: 'app-schedule-appointment',
  templateUrl: './schedule-appointment.component.html',
  styleUrls: ['./schedule-appointment.component.less', '../../../assets/style.less']
})

export class ScheduleAppointmentComponent implements OnInit {

  artistId:string

  // List of all the services that the artist that this page is for uses
  services;

  // The service that the user has just clicked
  selectedService;

  // Reactive Form Group for the services that the user selects to fill out forms for
  selectedServicesGroup:FormGroup;

  // All the form templates that exist within PMU Forms
  formTemplates:any[];

  // Date of the appointment that is being created.
  appointmentDate: Date

  // Current logged in user
  user: firebase.User;

  /// The name of the company that the user is scheduling an appointment with
  companyName:string

  ///
  todaysDate:string = new Date().toJSON().split('T')[0];

  /// Any errors when creating an appointment
  formError:string

  constructor(
    private route: Router,
    private firebaseService: FirebaseService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private logger: Logger
  ) { 
    this.artistId = this.activatedRoute.snapshot.paramMap.get("artistId")

    this.firebaseService.getArtist(this.artistId).subscribe(artist => {
      this.companyName = artist.get("businessName")
    })

    this.getAllServicesForArtist()

    this.firebaseService.isLoggedIn()
      .then(user => {
        this.user = user
      })
  }

  ngOnInit() {
    
  }

  cancel () {
    this.location.back()
  }

/**
 * It converts the selected services validation object to an array of service ids
 * @returns An array of the ids of the services that are selected.
 */
  convertSelectedServicesValidationObjectToArray () {
    
    let selectedServices = []
    for (let key in  this.selectedServicesGroup.controls) {
      if (this.selectedServicesGroup.get(key).value == true) {
        selectedServices.push(this.getIdOfServiceWithName(key))
      }
    }

    return selectedServices
  }

  /**
   * Returns the id for a service with a given name
   * @param name The name of the service to get the id for
   * @returns The id of the service with the given name
   */
  getIdOfServiceWithName (name) {
    this.logger.info(`Entering method getIdOfServiceWithName.
    Parameters: name=${name}`)

    const services = this.services.filter(service => service.service == name)

    this.logger.info('Exiting method getIdOfServiceWithName')

    return services[0].id
  }

  /**
   * Takes the user to the next screen where they can fill out forms for the services that they have selected   
   */
  nextButtonPressed () {
    const selectedServicesArray = this.convertSelectedServicesValidationObjectToArray()
    
    if (!this.appointmentDate) {
      this.formError = "Please select an appointment date"
      return
    }

    if (selectedServicesArray.length == 0) {
      this.formError = "You didn't select any services.  Please select which services you're getting at your upcoming appointment."
      return
    }

    // Create the appointment in firestore and then navigate to the next screen
    this.createAppointmentAndShowNextScreen(selectedServicesArray)
  }

  /**
   * 
   * @param services An array of services retrieved from the array. Should be of schema { id: int, service: string }
   */
  createSelectedServicesValidationObject (services) {
    this.logger.info(`Entering method createSelectedServicesValidationObject.
    Parameters: services=${services}`)

    let validationObject = {}

    services.map(service => {
      validationObject[service.service] = new FormControl('', [])    
    })
    this.logger.info('Exiting method createSelectedServicesValidationObject')

    return validationObject
  }

/**
 * Get all the services that this artist offers, and then get all the form templates for those services
 */
  getAllServicesForArtist() {
     // Get all the services that this artist offers
     this.firebaseService.getServicesForArtistWithId(this.artistId)
     .subscribe(services => {
       this.services = services
       this.selectedServicesGroup = new FormGroup(this.createSelectedServicesValidationObject(services))
       this.services.sort((a, b) => {
         if(a.service < b.service) { return -1; }
         if(a.service > b.service) { return 1; }
         
         return 0;
         })
     })    
 
     this.firebaseService.getAllFormsForServicesFromFirebase(this.services, this.artistId)
       .then(forms => {
        this.logger.info(`Retrieved all form templates from firestore for the artist with id ${this.artistId} - schedule-appointment.component.ts`)
        //  this.firebaseService.log(`Retrieved all form templates from firestore for the artist with id ${this.artistId} - schedule-appointment.component.ts`)
         this.formTemplates = forms
         this.formTemplates.sort((a, b) => {
           if(a.order < b.order) { return -1; }
           if(a.order > b.order) { return 1; }
           
           return 0;
         })

       }, err => {
        this.logger.error('Error retrieving all form templates from firestore - schedule-appointment.component.ts', err ? err : '')
        //  this.firebaseService.log("Error retrieving all form templates from firestore - schedule-appointment.component.ts", err)
       })      
  }

/**
 * It creates an appointment in firestore and then navigates to the next screen
 * @param {number[]} selectedServices - number[] - this is an array of the selected services that the
 * user has chosen.
 */
  async createAppointmentAndShowNextScreen (selectedServices: number[]) {
    this.logger.info(`Entering method createAppointmentAndShowNextScreen.
    Parameters: selectedServices=${selectedServices}`)
    const appointmentId = uuid.v4()
    const appointment = new Appointment(this.appointmentDate, appointmentId, this.user.uid, this.artistId, selectedServices  )
    
    try {
      await this.firebaseService.createAppointment( Object.assign({}, appointment) )
      this.route.navigateByUrl(`forms/services/${selectedServices}/artist/${this.artistId}/appointment/${appointmentId}`)
      this.logger.info('The appointment was created successfully in firestore')
      // this.firebaseService.log("The appointment was created successfully in firestore")
    } catch (err) {
      this.logger.error('Error creating the appointment in firebase', err ? err : '')
      // this.firebaseService.log("Error creating the appointment in firebase", err)
    }
  }
}
